/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import { connect } from 'react-redux';
import { WithLoading } from '../hoc/withLoading';
import { isMappingLoaded } from '../../../api/utils/aemEndpointUtil';
import SideNavigation from '../organisms/nav/SideNavigation';
import Breadcrumb from '../organisms/nav/Breadcrumb';
import NotificationHub from '../molecules/alert/NotificationHub';
import { selectMapping } from '../../../selectors/my-puratos/generics';

const style = { margin: 'auto' };

function EmptyPage({ children, mapping, hideBreadcrumb = false }) {
  return (
    <div className={'p-frame p-bgcolor-neutral-light'}>
      <WithLoading loading={!isMappingLoaded(mapping)} style={style}>
        <SideNavigation />

        <div className={'p-frame__main'}>
          {!hideBreadcrumb && <Breadcrumb mapping={mapping} />}

          <NotificationHub />

          {children}
        </div>
      </WithLoading>
    </div>
  );
}

const mapStateToProps = state => ({
  mapping: selectMapping(state)
});

export default connect(mapStateToProps)(EmptyPage);
